import { AfterViewInit, Component, HostListener, OnInit } from '@angular/core';
import { RouterOutlet, Router, RouterModule } from '@angular/router';
import { NzLayoutModule } from "ng-zorro-antd/layout";
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { CommonModule } from '@angular/common';
import { ApiService } from './Services/api.service';
import { AuthService } from './Services/auth.service';
import appData from './app-config/app-data.json';
import { UserInactiveService } from './Services/user-inactive.service';
import { NzToolTipModule } from "ng-zorro-antd/tooltip";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NzLayoutModule, CommonModule, NzMenuModule, NzIconModule, RouterModule,
    NzLayoutModule, NzInputModule, NzAvatarModule, NzBreadCrumbModule, NzButtonModule, NzToolTipModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, AfterViewInit {
  mainMenuList: any;
  menuCollapse: boolean = false;
  zoomLevel: any = 100;
  activeUrl: string = "";
  activeLiUrl: string | undefined;
  userToolTip:any;

  constructor(public api: ApiService, public router: Router, public authService: AuthService,
    public userInactiveService: UserInactiveService
  ) { }

  @HostListener('window:load', ['$event'])
  onLoad(event: Event): void {
    this.zoomLevel = Math.round(window.devicePixelRatio * 100);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.zoomLevel = Math.round(window.devicePixelRatio * 100);
  }

  ngOnInit(): void {
    this.handleNavigate();
  }

  ngAfterViewInit(): void {
    // this.handleNavigate();
    this.userToolTip = this.authService.name + ' ' + this.authService.username;
  }

  listNavigate(list: any) {
    if (!list.subMenuList.length) {
      this.router.navigate(["/" + list.routes[0]]);
      this.activeLiUrl = list.routes[0];
      this.activeUrl = '';
      this.api.validateMenuRoute('invalid');
    }
  }

handleNavigate() {
  this.activeLiUrl = '';
  this.activeUrl = '';
  this.api.mainMenuList = appData;

  const currentPath = this.router.url.replace("/", "");
  const matchedNode = this.api.mainMenuList.menuList.find((node: any) =>
    node.routes.includes(currentPath)
  );

  if (matchedNode) {
    if (matchedNode.subMenuList && matchedNode.subMenuList.length > 0) {
      this.activeUrl = currentPath.split('/')[0].split('-')[0];
    } else {
      this.activeLiUrl = currentPath;
    }
  }

  this.api.validateMenuRoute(this.router.url);
}

}





